"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    HIERARCHY: 'hierarchy',
    GEO: 'geo',
    HEX: 'hex',
    GRAPH: 'graph',
    TABLE: 'table',
    GEO_GRATICULE: 'geo-graticule',
    STATISTICS_METHODS: [
        'max',
        'mean',
        'median',
        'min',
        'mode',
        'product',
        'standardDeviation',
        'sum',
        'sumSimple',
        'variance',
    ],
};
